import { render } from "./SelectThePrinterModal.vue?vue&type=template&id=0c0a7ecf&scoped=true"
import script from "./SelectThePrinterModal.vue?vue&type=script&lang=js"
export * from "./SelectThePrinterModal.vue?vue&type=script&lang=js"

import "./SelectThePrinterModal.vue?vue&type=style&index=0&id=0c0a7ecf&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0a7ecf"]])

export default __exports__